const Cropper = require("cropperjs");

Eloca.behaviors.imagem = function (context) {

    window.timeout = null;
    window.video = null;
    window.cropper = null;

    function getModalFromTrigger($el) {
        const target = $el.closest("[data-target]").attr("data-target") || $el.attr("data-target");
        return target ? $(target) : $(".modal.show").first();
    }

    $(".js-modal-avatar-cliente, .js-modal-avatar-usuario").on("click", function () {
        const $modal = getModalFromTrigger($(this));

        if (window.cropper != null) {
            window.cropper.destroy();
            const canvasAvatar = $modal.find(".canvas-avatar").get(0);
            if (canvasAvatar) {
                const ctx = canvasAvatar.getContext("2d");
                ctx.canvas.height = "206px";
                ctx.canvas.width = "466px";
                ctx.clearRect(0, 0, canvasAvatar.width, canvasAvatar.height);
            }
            window.cropper = null;
        }

        $modal.find(".js-foto-avatar-input").trigger("click");
    });

    $(".js-trigger-avatar-input").on("click", function () {
        const $modal = $(this).closest(".modal");

        if (window.cropper != null) {
            window.cropper.destroy();
            const canvasAvatar = $modal.find(".canvas-avatar").get(0);
            if (canvasAvatar) {
                const ctx = canvasAvatar.getContext("2d");
                ctx.canvas.height = "206px";
                ctx.canvas.width = "466px";
                ctx.clearRect(0, 0, canvasAvatar.width, canvasAvatar.height);
            }
            window.cropper = null;
        }

        $modal.find(".js-foto-avatar-input").trigger("click");
    });

    $(".js-foto-avatar").on("click", function () {
        const $modal = $(this).closest(".modal");

        $modal.find(".js-crop-container").toggleClass("d-none");
        $modal.find(".js-controle-crop").toggleClass("d-none");
        $modal.find(".video-avatar").toggleClass("d-none");
        $modal.find(".js-controle-video").toggleClass("d-none");

        navigator.mediaDevices.getUserMedia({ video: true })
            .then(function (mediaStream) {
                window.video = $modal.find(".js-video-avatar, #video")[0];
                if (window.video) {
                    window.video.srcObject = mediaStream;
                    window.video.play();
                }
            })
            .catch(function (err) {
                console.log("Não há permissões para acessar a webcam");
            });
    });

    $(".js-cancelar-captura").on("click", function () {
        const $modal = $(this).closest(".modal");

        $modal.find(".js-crop-container").toggleClass("d-none");
        $modal.find(".js-controle-crop").toggleClass("d-none");
        $modal.find(".video-avatar").toggleClass("d-none");
        $modal.find(".js-controle-video").toggleClass("d-none");

        if (window.video != null) {
            if (window.video.srcObject && window.video.srcObject.getTracks) {
                window.video.srcObject.getTracks()[0].stop();
            }
            window.video = null;
        }
    });

    $(".js-capturar-imagem").on("click", function () {
        const $modal = $(this).closest(".modal");

        if (window.cropper != null) {
            window.cropper.destroy();
        }
        const canvasAvatar = $modal.find(".canvas-avatar").get(0);
        if (!canvasAvatar || !window.video) return;

        canvasAvatar.height = window.video.videoHeight;
        canvasAvatar.width = window.video.videoWidth;
        const ctx = canvasAvatar.getContext("2d");
        ctx.drawImage(window.video, 0, 0);
        window.cropper = new Cropper(canvasAvatar, {
            aspectRatio: 8 / 8,
            crop(event) {},
        });

        $modal.find(".js-crop-container").toggleClass("d-none");
        $modal.find(".js-controle-crop").toggleClass("d-none");
        $modal.find(".video-avatar").toggleClass("d-none");
        $modal.find(".js-controle-video").toggleClass("d-none");

        if (window.video.srcObject && window.video.srcObject.getTracks) {
            window.video.srcObject.getTracks()[0].stop();
        }
        window.video = null;
    });

    $(".js-foto-avatar-input").on("change", function () {
        const $modal = $(this).closest(".modal");
        const canvasAvatar = $modal.find(".canvas-avatar");

        if (this.files && this.files[0]) {
            const canvasCtx = canvasAvatar.get(0)?.getContext("2d");
            if (!canvasCtx) return;

            if (this.files[0].type.match(/^image\//)) {
                if (window.cropper != null) {
                    window.cropper.destroy();
                }
                const reader = new FileReader();
                reader.onload = function (evt) {
                    const img = new Image();
                    img.onload = function () {
                        canvasCtx.canvas.height = img.height;
                        canvasCtx.canvas.width = img.width;
                        canvasCtx.drawImage(img, 0, 0);
                        window.cropper = new Cropper(canvasAvatar.get(0), {
                            aspectRatio: 8 / 8,
                            crop(event) {},
                        });
                    };
                    img.src = evt.target.result;
                };
                reader.readAsDataURL(this.files[0]);
            } else {
                showToastWarning(context, "Tipo de aquivo invalido! Por favor selecione uma imagem.");
            }
            $(this).val("");
        } else {
            showToastWarning(context, "Nenhum arquivo escolhido.");
        }
    });

    $(".js-btn-restore").on("click", function () {
        if (window.cropper) window.cropper.reset();
    });

    $(".js-zoom-in").on("mousedown", function () {
        if (window.timeout == null && window.cropper) {
            window.timeout = setInterval(function () {
                window.cropper.zoom(0.1);
            }, 25);
        }
        return false;
    });

    $(".js-zoom-in").on("mouseup", function () {
        return limparRepeticao();
    });

    $(".js-zoom-out").on("mousedown", function () {
        if (window.timeout == null && window.cropper) {
            window.timeout = setInterval(function () {
                window.cropper.zoom(-0.1);
            }, 25);
        }
        return false;
    });

    $(".js-zoom-out").on("mouseup", function () {
        return limparRepeticao();
    });

    $(".js-btn-girar-dir").on("mousedown", function () {
        if (window.timeout == null && window.cropper) {
            window.timeout = setInterval(function () {
                window.cropper.rotate(5);
            }, 25);
        }
        return false;
    });

    $(".js-btn-girar-dir").on("mouseup", function () {
        return limparRepeticao();
    });

    $(".js-btn-girar-esq").on("mousedown", function () {
        if (window.timeout == null && window.cropper) {
            window.timeout = setInterval(function () {
                window.cropper.rotate(-5);
            }, 25);
        }
        return false;
    });

    $(".js-btn-girar-esq").on("mouseup", function () {
        return limparRepeticao();
    });

    $(".js-btn-mover-cima").on("mousedown", function () {
        if (window.timeout == null && window.cropper) {
            window.timeout = setInterval(function () {
                window.cropper.move(0, -2);
            }, 25);
        }
        return false;
    });

    $(".js-btn-mover-cima").on("mouseup", function () {
        return limparRepeticao();
    });

    $(".js-btn-mover-baixo").on("mousedown", function () {
        if (window.timeout == null && window.cropper) {
            window.timeout = setInterval(function () {
                window.cropper.move(0, 2);
            }, 25);
        }
        return false;
    });

    $(".js-btn-mover-baixo").on("mouseup", function () {
        return limparRepeticao();
    });

    $(".js-btn-mover-esq").on("mousedown", function () {
        if (window.timeout == null && window.cropper) {
            window.timeout = setInterval(function () {
                window.cropper.move(-2, 0);
            }, 25);
        }
        return false;
    });

    $(".js-btn-mover-esq").on("mouseup", function () {
        return limparRepeticao();
    });

    $(".js-btn-mover-dir").on("mousedown", function () {
        if (window.timeout == null && window.cropper) {
            window.timeout = setInterval(function () {
                window.cropper.move(2, 0);
            }, 25);
        }
        return false;
    });

    $(".js-btn-mover-dir").on("mouseup", function () {
        return limparRepeticao();
    });

    function salvarImagemCliente(blob) {
        const formData = new FormData();
        formData.append("clienteId", $("#id-cliente").val());
        formData.append("foto", blob, "imagetest.jpeg");

        $.ajax({
            url: siteUrl("/painel/clientes/add-foto"),
            headers: { "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content") },
            type: "post",
            data: formData,
            contentType: false,
            processData: false,
            success: function (res) {
                if (res.sucesso !== false) {
                    window.location.reload(true);
                } else {
                    showToastDanger(context, res.message || "Erro ao salvar imagem.");
                }
            },
            error: function (err) {
                console.log(err);
                showToastDanger(context, "Se persistir entre em contato com o suporte.");
                $("#overlayer-loading").removeClass("show-overlayer");
            },
        });
    }

    function salvarImagemUsuario(blob) {
        const formData = new FormData();
        formData.append("foto", blob, "avatar.jpeg");

        $.ajax({
            url: siteUrl("/painel/imagem/upload-avatar"),
            headers: { "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content") },
            type: "post",
            data: formData,
            contentType: false,
            processData: false,
            success: function (res) {
                if (res.path) {
                    $("#imagem-usuario").val(res.path);
                    const $row = $("#imagem-usuario").closest(".row");
                    const $preview = $row.find(".client__photo img");
                    const $icon = $row.find(".client__icon");
                    if ($preview.length && res.url) {
                        $preview.attr("src", res.url);
                    } else if ($icon.length && res.url) {
                        $icon.replaceWith(
                            '<div class="client__photo js-modal-avatar-usuario" data-toggle="modal" data-target="#avatarUsuario">' +
                                '<img src="' + res.url + '" alt="Foto do usuário" class="small">' +
                            "</div>"
                        );
                    }
                    $("#avatarUsuario").modal("hide");
                } else {
                    showToastDanger(context, res.error || "Erro ao fazer upload da imagem.");
                }
            },
            error: function (err) {
                console.log(err);
                showToastDanger(context, "Se persistir entre em contato com o suporte.");
            },
            complete: function () {
                $("#overlayer-loading").removeClass("show-overlayer");
            },
        });
    }

    $(".js-add-imagem-cliente").on("click", function () {
        if (!window.cropper) return;
        $("#overlayer-loading").addClass("show-overlayer");

        window.cropper
            .getCroppedCanvas({
                fillColor: "#fff",
                imageSmoothingEnabled: false,
                imageSmoothingQuality: "high",
            })
            .toBlob(salvarImagemCliente, "image/jpeg", 1);
    });

    $(".js-add-imagem-usuario").on("click", function () {
        if (!window.cropper) return;
        $("#overlayer-loading").addClass("show-overlayer");

        window.cropper
            .getCroppedCanvas({
                fillColor: "#fff",
                imageSmoothingEnabled: false,
                imageSmoothingQuality: "high",
            })
            .toBlob(salvarImagemUsuario, "image/jpeg", 1);
    });

    function limparRepeticao() {
        clearInterval(window.timeout);
        window.timeout = null;
        return false;
    }
};
